/**
 * Fixed bottom CTAs publish their height here (via usePublishedHeight) so the
 * layout reserves room for them after the footer. See Layout.scss.
 */
export const DOCKED_CTA_HEIGHT_PROPERTY = "--rbc-docked-cta-height";
